import api from './api'

class LocationService {
    async getOne(locationUuid) {
        return api.get('/location/' + locationUuid)
    }

    async create(location) {
        return api.post('/' + location.model + '/' + location.model_uuid + '/location', {
                address: location.address,
                number: location.number,
                additional: location.additional,
                zip_code: location.zip_code,
                town: location.town,
            })
            .then(response => response.data);
    }

    async modify(location) {
        return api.patch('/location/' + location.uuid, {
                address: location.address,
                number: location.number,
                additional: location.additional,
                zip_code: location.zip_code,
                town: location.town,
            })
            .then(response => response.data)
    }

    async delete(location) {
        return api.delete('/' + location.model + '/' + location.model_uuid + '/location/' + location.uuid)
            .then(response => response.data);
    }
}

export default new LocationService();
